import { Attribute, Directive, Injector, forwardRef } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';
import { AppComponentBase } from '@shared/app-component-base';
import * as moment from 'moment';

@Directive({
  selector: '[validateGreaterOrEqualThan][ngModel],[validateGreaterOrEqualThan][formControl]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => GreaterOrEqualThanValidator),
      multi: true
    }
  ]
})
export class GreaterOrEqualThanValidator extends AppComponentBase implements Validator {
  constructor(injector: Injector, @Attribute('validateGreaterOrEqualThan') public startDate: string) {
    super(injector);
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const startDateControl = control.root.get(this.startDate);
    const endDateControl = control;

    if (!startDateControl || !endDateControl) {
      return null;
    }

    const startDate = moment(startDateControl.value, this.getDateInputFormat(), true);
    const endDate = moment(endDateControl.value, this.getDateInputFormat(), true);

    return startDate.isAfter(endDate, 'day') ? { validateGreaterOrEqualThan: true } : null;
  }
}
